/**
 * Shared layout tokens for card list grids (fragments, compositions, broadcasts, etc.).
 * Prefer CardsGrid / CardsGridItem over hand-rolled MUI Grid containers.
 */

/** Vertical gap between card rows (theme spacing units). */
export const CARDS_GRID_ROW_SPACING = 6;

/** Horizontal gap for standard 12-column card grids. */
export const CARDS_GRID_COLUMN_SPACING = 2;

/**
 * Column count for density-based card grids.
 * 60 allows: 2→30, 3→20, 4→15, 5→12, 6→10 cols per row.
 */
export const CARDS_GRID_DENSE_COLUMNS = 60;

/** Horizontal gap for dense 60-column card grids (responsive by breakpoint). */
export const CARDS_GRID_DENSE_COLUMN_SPACING = {
  md: 2,
  lg: 3,
  xl: 4,
};

/** Density keys aligned with ItemsViewLayout grid modes (excludes list). */
export type CardsGridDensity = 'gridWide' | 'gridNormal' | 'gridCompact';

/**
 * Item sizes for dense grids, keyed by density.
 * Pair with CardsGrid columns={CARDS_GRID_DENSE_COLUMNS}.
 */
export const CARDS_GRID_ITEM_SIZE_BY_DENSITY: Record<
  CardsGridDensity,
  { xs: 60; sm: number; md: number; lg: number; xl: number }
> = {
  gridWide: { xs: 60, sm: 30, md: 20, lg: 20, xl: 15 },
  gridNormal: { xs: 60, sm: 30, md: 20, lg: 15, xl: 12 },
  gridCompact: { xs: 60, sm: 30, md: 20, lg: 12, xl: 10 },
};

/** Standard 12-col item sizes (~1 / 2 / 3 / 4 cards per row by breakpoint). */
export const CARDS_GRID_ITEM_SIZE = { xs: 12, sm: 6, md: 4, xl: 3 };
